import { render, staticRenderFns } from "./TableWlAppointments.vue?vue&type=template&id=42e6de09&scoped=true"
import script from "./TableWlAppointments.vue?vue&type=script&lang=js"
export * from "./TableWlAppointments.vue?vue&type=script&lang=js"
import style0 from "./TableWlAppointments.vue?vue&type=style&index=0&id=42e6de09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e6de09",
  null
  
)

export default component.exports